import 'amstock3/amcharts/amcharts'
import 'amstock3/amcharts/serial'
import 'amstock3/amcharts/amstock'
import 'amstock3/amcharts/plugins/export/export'
import 'amstock3/amcharts/themes/light'

function StatisticsChart($tableWrap, opt_opts){
	var that = this;
	opt_opts = opt_opts || {};
	that.$tableWrap = $tableWrap;
	that.$wrap = $tableWrap.find('.render-chart');
	that.$chartContainer = that.$wrap.find(".chart-container");
	that.$preloader = that.$wrap.find(".preloader");
	that.$alert = that.$wrap.find(".alert");
	that.reloadTimeoutId = 0;
	that.url = that.$wrap.data("url")||"/statistics";
	that.tableId = that.$wrap.data("table");
	that.xhr = null;
	that.chart = null;
	that.chartPanelHeight = 400;
	that.colors = [
		'#5E0170','#357266', '#00B69D',
		'#0097D6', '#FCAF17', '#5BCBF5',
		'#E31C48','#00B07D'
	];
	that.deselectEvent = false
	that.interval = null;
	that.decimalSeparator = that.$wrap.data("decimalSeparator");
	that.thousandsSeparator = that.$wrap.data("thousandsSeparator");
	that.dateinterval_default_limit = parseInt(that.$wrap.data("dateinterval_default_limit")) || 10;
	that.indicators = that.$wrap.data('indicators') || [];
	that.chartPanels = that.$wrap.data('panels');
	that.chartTypes = that.$wrap.data('types');
	that.updateUrl = false;
	that.bullets = ["round", "square", "triangleUp", "triangleDown", "triangleLeft", "triangleRight", "bubble", "diamond", "xError", "yError"];
	that.dateFormats = [
		{period:"YYYY", format:"YYYY"},
		{period:"MM", format:"YYYY-MM"}
	];

	that.init();


	that.$tableWrap.data('chartInstance', that);

	AmCharts.formatDate = function(date, format, event){
		return that.formatDate(date);
	};
};

StatisticsChart.prototype.init = function(){
	var that = this;

	var sids = that.$tableWrap.find("input[name='sids']").val();

	if(sids){
		that.indicators = [];
		var rawIs = sids.split('__');
		for (var i in rawIs){

			var rawI = rawIs[i].split('-');

			if(rawI.length == 3){
				var id = rawI[0];
				var panel = rawI[1];
				var type = rawI[2];
				var $btn = that.$tableWrap.find('.i-mng-actions > a[data-id="'+id+'"]');
				if($btn.length){
					var ind = {
						id: $btn.data('id'),
						code: $btn.data('code'),
						panel: that.chartPanels.indexOf(panel) > -1?panel:that.chartPanels[0],
						type: that.chartTypes.indexOf(type) > -1?type:that.chartTypes[0]
					};
					that.indicators.push(ind);
				}
			}
		}
	}

	$('a#charts-tab').on('shown.bs.tab', function (e){
		that.checkVisibility();
	})
	// $('a#charts-tab').on('hidden.bs.tab', function (e){
	// 	that.checkVisibility();
	// })


	// that.$toggle.on('click', function (e) {
	// 	e.preventDefault();
	// 	that.$wrap.toggleClass('d-none');
	// 	that.checkVisibility();
	// 	Cookies.set('stats_show_charts', !that.$wrap.hasClass('d-none'), { expires: 180 })
	// })
	that.checkVisibility()
	that.updateTableChartStatus();
};
StatisticsChart.prototype.checkVisibility = function () {
	var that = this;
	if(that.$wrap.closest('.tab-pane').hasClass('active')){
		that.reloadChartData()
	}
}

StatisticsChart.prototype.destroyChart = function(){
	var that = this;
	if(that.chart){
		that.$chartContainer.hide();
	}
};
StatisticsChart.prototype.initChart = function(){
	var that = this;
	var chartTitle = that.$wrap.data("title");

	that.chart = AmCharts.makeChart(that.$chartContainer[0], {
		"hideCredits": true,
		path: '/public/build/amcharts/',
		"type": "stock",
		//"dataDateFormat": "YYYY-MM-DD",
		//"dateFormat": "YYYY-MM",
		colors: that.colors,
		"panelsSettings": {
            autoMargins: true
			/*
			"marginLeft": 40,
			"marginRight": 40,
			"marginTop": 0
			*/
		},
		valueAxesSettings: {
			"inside": false
		},

		chartCursorSettings: {
			cursorColor: that.colors[0],
			categoryBalloonEnabled: true,
			categoryBalloonColor: that.colors[0],
			onePanelOnly: true,
			"valueBalloonsEnabled": true,
			"fullWidth": false,
			"cursorAlpha": 1,
			//"valueLineBalloonEnabled": false,
			//"valueLineEnabled": false,
			categoryBalloonDateFormats: [{period:"YYYY", format:"YYYY"}, {period:"MM", format:"YYYY-MM"}, {period:"WW", format:"MMM DD, YYYY"}, {period:"DD", format:"YYYY-MM"}, {period:"hh", format:"JJ:NN"}, {period:"mm", format:"JJ:NN"}, {period:"ss", format:"JJ:NN:SS"}, {period:"fff", format:"JJ:NN:SS"}],
			categoryBalloonFunction: function (category) {
				return that.formatDate(category)
			}
		},
		legendSettings: {
			position: "bottom"
		},
		chartScrollbarSettings: {
			position: 'top',
			graphType: 'line',
			selectedGraphFillColor: that.colors[0],
			selectedBackgroundColor: that.colors[0],
			selectedBackgroundAlpha: 0.5,
			updateOnReleaseOnly: true,
			usePeriod: "MM"
		},
		categoryAxesSettings: {
			inside: false,
			groupToPeriods: ["MM"],
			parseDates: false,
			dateFormats: [
				{period:"YYYY", format:"YYYY"},
				{period:"MM", format:"YYYY-MM"}
			],
			minPeriod: 'MM',
			gridThickness: 0
		},
		balloon: {
			fontSize: 10,
			maxWidth: 500,
			borderThickness: 1,
			textAlign: 'left'
		},
		dataSets: [
			{
				"title": "",
				fieldMappings: [],
				categoryField: 'date'
			}
		],
		export: {
			enabled: true,
			position: "bottom-right",
			menu: [ {
				class: "export-main",
				menu: [
					{label: chart_i18n.downloadJPEG, format: "jpg"},
					{label: chart_i18n.downloadPNG, format: "png"},
					{label: chart_i18n.downloadSVG, format: "svg"},
					{label: chart_i18n.printChart,format: "print"}
					]
			}
			]
		}
	})

	that.chart.addListener("rendered", function () {
		that.zoomChart()
	});
	that.zoomChart();
};
StatisticsChart.prototype.zoomChart = function() {
	var that = this;
	if(!that.chart.mainDataSet) return;
	var dataProvider = that.chart.mainDataSet.dataProvider;
	if(dataProvider && dataProvider.length >= that.dateinterval_default_limit){
		var fromD = new Date(Date.parse(dataProvider[dataProvider.length - that.dateinterval_default_limit].date))
		var toD = new Date(Date.parse(dataProvider[dataProvider.length - 1].date) + 60*60 * 24 * 1000 * 30)
		that.chart.zoom(fromD, toD);
	}
}

StatisticsChart.prototype.reloadChartData = function(){
	var that = this;


	if(that.indicators.length){
		var reqData = {
			table_id: that.tableId,
			series: that.indicators
		};

		that.$preloader.show();
		that.xhr = $.ajax({
			type: "POST",
			url: this.url + "/chart_data",
			data: reqData,
			dataType: 'json',
			success: function (response) {
				that.xhr = null;
				if (response) {
					that.redrawChart(response);
				}
				that.$preloader.hide();
			}
		})
	}else{
		that.$alert.show();
		that.updateLocation();
		that.updateTableChartStatus();
		that.destroyChart();
	}
};
StatisticsChart.prototype.redrawChart = function(chartData){
	var that = this;

	if(chartData.series.length == 0){
		that.$chartContainer.hide();
		return;
	}else{
		that.$chartContainer.show();
	}
	if(!that.chart) that.initChart();

	while (that.chart.panels.length){
		that.chart.removePanel(that.chart.panels[0])
	}

	if(!that.chart.mainDataSet){
		that.chart.mainDataSet = new AmCharts.DataSet();
		that.chart.mainDataSet.categoryField = 'date';
	}

	that.chart.mainDataSet.fieldMappings = [];
	that.chart.mainDataSet.dataProvider = chartData.dataset;

	that.interval = chartData.interval;
	switch (that.interval){
		case 'P1Y':
			that.chart.categoryAxesSettings.minPeriod = 'YYYY';
			break;
		case 'P1M':
		case 'P3M':
			that.chart.categoryAxesSettings.minPeriod = 'MM';
			break;

	}

	var panels = [];
	for (var panelId in chartData.series){
		var panelSids = chartData.series[panelId];

		for (var index in panelSids){
			var serie = panelSids[index];
			var code = serie.code


			that.chart.mainDataSet.fieldMappings.push({
				"fromField": code,
				"toField": code
			});

			var panel = null;
			for(var i = 0; i<panels.length; i++){
				if(panelId == panels[i].id){
					panel = panels[i];
					break;
				}
			}
			if(panel == null){
				panel = new AmCharts.StockPanel();
				panel.id = panelId;
				panel.fontFamily = 'Roboto, sans-serif';
				panel.decimalSeparator = that.decimalSeparator
				panel.thousandsSeparator = that.thousandsSeparator
				panel.categoryAxis = {
				};
				panel.stockLegend = {
					useGraphSettings: true,
					labelText: '[[title]]',
					valueText: null,
					equalWidths: true
				};
				panel.valueAxes = [];
				panels.push(panel);
			}



			var valueAxisId = serie.unit;
			var unit = chartData.units[valueAxisId];
			var axisTitle = unit.title;

			if(serie.value_format && serie.value_format.power){
				valueAxisId += "_" + serie.value_format.power;
			}

			if(unit.powers.length){
				for(var powerKey in unit.powers){
					var power = unit.powers[powerKey];
					valueAxisId = valueAxisId + "_" + power.id
					axisTitle = axisTitle + "(" + power.title + ")"
				}
			}

			var valueAxesExist = false;
			for(var k in panel.valueAxes){
				var valueAxe = panel.valueAxes[k];
				if(valueAxisId == valueAxe.id){
					valueAxesExist = true;
					break;
				}
			}
			if(!valueAxesExist){

				panel.addValueAxis(
					{
						id: valueAxisId,
						title: axisTitle,
						titleFontSize: 10,
						titleBold: false,
						position: panel.valueAxes.length % 2 == 0 ? 'left': 'right',
						integersOnly: serie.value_format && serie.value_format.decimal == 0
					}
				)
			}

			var valueSuffix = '';
			if(serie.value_format && serie.value_format.power){
				if(unit.title){
					valueSuffix += ' ' + unit.title + ' ';
				}
				for(var powerIndex in unit.powers){
					var power = unit.powers[powerIndex];
					if(power.id == serie.value_format.power){
						valueSuffix += '(' + power.title + ')';
						break;
					}
				}
			}

			var graph = new AmCharts.StockGraph();
			graph.id = "g_" + panel.id + "_" + panel.stockGraphs.length;
			if(serie.subtitles){
				graph.title = serie.title + ' / ' + serie.subtitles.join(" / ")
			}else{
				graph.title = serie.title
			}
			graph.type = that.getStockGraphType(serie.type);
			graph.valueField = code;
			graph.useDataSetColors = false;
			graph.valueAxis = valueAxisId;
			graph.lineColor = that.colors[panel.stockGraphs.length % that.colors.length];
			//graph.balloonText = code + '<br/> ' + graph.title + ': <b>[[value]] '+valueSuffix+'</b>';
			graph.balloonText = serie.title + ': <b>[[value]] ' + valueSuffix + '</b>';
			if(serie.type == "column"){
				graph.fillAlphas = 1;
				//graph.bullet = 'square';
			}else if(serie.type == "area"){
				graph.fillAlphas = 0.7;
				//graph.bullet = 'triangleUp';
			}else if(serie.type == "line"){
				graph.fillAlphas = 0;
				graph.bullet = that.bullets[panel.stockGraphs.length % that.bullets.length];
				//graph.bullet = 'round';
			}


			panel.addStockGraph( graph );

		}
	}

	panels.sort(function (a, b) {
		return a.id < b.id ? -1:1;
	})

	panels.forEach(function (el, index) {
		//el.percentHeight = index == 0 ? (100 - 25*(panels.length-1)) : 25
		that.chart.addPanel(el)
	});

	that.chart.chartScrollbarSettings.graph = that.chart.panels[0].stockGraphs[0].id;
	that.$chartContainer.height(that.chartPanelHeight * panels.length);
	setTimeout(function () {
		that.chart.validateNow(true);
	}, 100)

	that.updateTableChartStatus();
	if(that.updateUrl){
		that.updateLocation();
	}

	return;
};
StatisticsChart.prototype.toggleChildrens = function($toggle){
	var hideChildrens = $toggle.find("i.fa").hasClass('fa-minus-square-o');

	if(hideChildrens){
		$toggle.find("i.fa").removeClass('fa-minus-square-o').addClass('fa-plus-square-o');
		$toggle.parent().addClass("collapsed");
	}else{
		$toggle.find("i.fa").removeClass('fa-plus-square-o').addClass('fa-minus-square-o');
		$toggle.parent().removeClass("collapsed");
	}
};

StatisticsChart.prototype.getStockGraphType = function(type) {
	var that = this;
	switch (type){
		case 'line':
		case 'column':
			return type;
			break;
	}
	return 'line'
}
StatisticsChart.prototype.formatDate = function(date) {
	var that = this;
	if(that.interval == 'P3M'){
		var q = '';
		switch (date.getMonth()){
			case 0:
				q = 'q1';
				break;
			case 3:
				q = 'q2';
				break;
			case 6:
				q = 'q3';
				break;
			case 9:
				q = 'q4';
				break;
		}
		if(chart_i18n[q]){
			return date.getFullYear() + " - " + chart_i18n[q];
		}else{
			return null
		}
	}else if(that.interval == 'P1Y'){
		return date.getFullYear().toString()
	}

	return date.getFullYear() + " - " + that.formatNumber(date.getMonth()+1);
}
StatisticsChart.prototype.updateLocation = function () {
	var that = this;
	var href = window.location.href;

	var panelParams = [];
	var sidsParam = '';
	for (var k in that.indicators){
		var i = that.indicators[k];

		panelParams.push(i.id + "-" + i.panel + "-" + i.type)
	}
	if(panelParams.length > 0){
		sidsParam = "sids=" + panelParams.join("__");
	}

	if(!sidsParam){
		href = href.replace(/(\?|&)sids=([^&]*)/ig, '');
	}else{
		if(href.indexOf("sids") > -1){
			href = href.replace(/(\?|&)sids=([^&]*)/ig, "$1" + sidsParam);
		}else{
			if(href.indexOf("?") > -1){
				href += "&" + sidsParam
			}else{
				href += "?" + sidsParam
			}
		}
	}
	window.history.replaceState({}, null, href);
	that.$tableWrap.find("input[name='sids']").val(panelParams.join("_"));
};
StatisticsChart.prototype.updateTableChartStatus = function () {
	var that = this;
	//remove chart status
	that.$tableWrap.find('.i-status > .fa-chart-line').remove();
	for (var k in that.indicators){
		var i = that.indicators[k];
		var id = i.id
		if(!id){
			id = i.code;
		}

		that.$tableWrap.find('.i-mng-actions[data-code="'+i.code+'"][data-id="'+id+'"]').each(function () {
			var $statusWrap = $(this).parents('th').find('.i-status');
			if($statusWrap.find('.fa-chart-line').length == 0){
				$statusWrap.append('<em class="fa-solid fa-chart-line"></em>');
			}
		})

	}
};
StatisticsChart.prototype.formatNumber = function(number) {
	return (number < 10 ? '0' : '') + number;
};
StatisticsChart.prototype.findIndicator = function(id, code, panel, type) {
	var that = this;
	for (var k in that.indicators){
		var i = that.indicators[k];
		if(i.id == id && i.code == code && i.type == type && i.panel == panel){
			return i
		}
	}
	return null
};
StatisticsChart.prototype.removeIndicator = function(indicator) {
	var that = this;
	for (var k in that.indicators){
		if(indicator == that.indicators[k]){
			that.indicators.splice(k, 1)
			break;
		}
	}
	that.updateUrl = true;
}
StatisticsChart.prototype.addIndicator = function(id, code, panel, type) {
	var that = this;
	var indicator = {
		id:id,
		code:code,
		panel:panel,
		type:type
	};
	that.indicators.push(indicator);
	that.updateUrl = true;
	return indicator;
}


export default StatisticsChart;